import { combineReducers } from 'redux';

import { reducer as authReducer } from './auth';
import { reducer as crudReducer } from './crud';
import { reducer as erpReducer } from './erp';
import { reducer as settingsReducer } from './settings';

import * as actionTypes from './auth/types';
import employeesReducer from './settings/employessReducer';
import sessionReducer from './screenShorts/screenShortSaveSlice';
import rolePermissionsReducer from './rolesPermissions';

// Combine all reducers.

const appReducer = combineReducers({
  auth: authReducer,
  crud: crudReducer,
  erp: erpReducer,
  settings: settingsReducer,
  employee: employeesReducer,
  session: sessionReducer,
  rolePermissions: rolePermissionsReducer
});

const rootReducer = (state, action) => {
  if (action.type === actionTypes.LOGOUT_SUCCESS) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;